import React from 'react';
import AnchorsContent from './internal/AnchorsContent';
import BreadcrumbContext from './internal/BreadcrumbContext';
const Anchors = ({ anchors = [], isLoading = false, getTitle, getRoute, children, }) => {
    const { depth } = React.useContext(BreadcrumbContext);
    return (<AnchorsContent anchors={anchors} depth={depth} getRoute={getRoute} getTitle={getTitle} isLoading={isLoading}>
      {children}
    </AnchorsContent>);
};
export default Anchors;
